import script from "./MobilePartCollectionsLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./MobilePartCollectionsLayout.vue?vue&type=script&setup=true&lang=ts"

import "./MobilePartCollectionsLayout.vue?vue&type=style&index=0&id=fe274dfa&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe274dfa"]])

export default __exports__